module.exports = __webpack_public_path__ + "ac921463c4862aae7a65f273c15f8d76.svg";